// extracted by mini-css-extract-plugin
export default {"trigger":"MoreDropdown_trigger--t2R","moreMenu":"MoreDropdown_moreMenu--umM","content":"MoreDropdown_content--O6B","triggerContainer":"MoreDropdown_triggerContainer--i2G"};